import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import PeriodType from "@/models/Shared/PeriodType";
import FixedTermMaturityType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityType";
import FixedTermMaturityActionType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityActionType";
import Amount from "@/models/Shared/Amount";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class DepositFixedTermMaturitySettings extends BaseProductSettings {
    maturityWindowPeriodType: PeriodType = PeriodType.Day;
    maturityWindowPeriodValue: number = 30;
    maturityType: FixedTermMaturityType = FixedTermMaturityType.ReinvestFullBalance;
    maturityAction1Type: FixedTermMaturityActionType = FixedTermMaturityActionType.Reinvest;
    maturityAction1Product: EntityIdentifier;
    maturityAction1ProductId: string;
    maturityAction1ProductIssueId: string;
    maturityAction1Amount: Amount;
    maturityAction2Type: FixedTermMaturityActionType;
}